import { Theme } from '@mui/material';
import { CUSTOM_BREAKPOINT_1024 } from 'shared/custom/constants/commonConstants';

export const gallerySX = (theme: Theme) => ({
	width: '100%',
	aspectRatio: '1 / 1',
	objectFit: 'contain',
	[theme.breakpoints.between(CUSTOM_BREAKPOINT_1024, 'xl')]: {
		maxWidth: '480px',
	},
	[theme.breakpoints.up('xl')]: {
		maxWidth: '600px',
	},
});
